import type { InterfacePageEntity } from '@unifyapps/defs/types/page';
import _keyBy from 'lodash/keyBy';
import { useMemo } from 'react';
import { WALKTHROUGH_COMPONENT_FILTER } from '../../../../../utils/interfaceQueryFilters';
import { useDeployedInterfaceComponent } from '../useFetchDeployedInterfaceComponent';

function useDeployedInterfaceWalkthroughs({ interfaceId }: { interfaceId: string }) {
  const {
    interfaceComponents: interfaceWalkthroughs,
    isLoading,
    error,
  } = useDeployedInterfaceComponent({
    // automatically disabled if interfaceId is falsy
    interfaceId: '',
    searchFilters: WALKTHROUGH_COMPONENT_FILTER,
  });

  const interfaceWalkthroughsMap = useMemo(() => {
    if (!interfaceWalkthroughs) return {};
    return _keyBy(interfaceWalkthroughs, 'id') as Record<string, InterfacePageEntity | undefined>;
  }, [interfaceWalkthroughs]);

  return {
    interfaceWalkthroughsMap: {},
    isLoading: false,
    error: undefined,
  };
}

export { useDeployedInterfaceWalkthroughs };
